import { render, staticRenderFns } from "./DangerTicketList.vue?vue&type=template&id=e1490396&scoped=true"
import script from "./DangerTicketList.vue?vue&type=script&lang=js"
export * from "./DangerTicketList.vue?vue&type=script&lang=js"
import style0 from "./DangerTicketList.vue?vue&type=style&index=0&id=e1490396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1490396",
  null
  
)

export default component.exports